'use client';

import { useState } from 'react';

import type { EmblaCarouselType } from 'embla-carousel';

import { AnimatedSticker } from '~/components/animated-sticker';
import { Carousel, CarouselContent, CarouselItem } from '~/components/ui/carousel/carousel';

interface Sticker {
  id: string;
  image: string;
}

interface SaleStickerCarouselProps {
  stickers: Sticker[];
}

export const SaleStickerCarousel = ({ stickers }: SaleStickerCarouselProps) => {
  const [, setApi] = useState<EmblaCarouselType | undefined>(undefined);

  const stickerImages = stickers.map((sticker) => sticker.image).filter(Boolean);

  if (stickers.length === 0) {
    return null;
  }

  return (
    <Carousel
      className="relative w-full"
      images={stickerImages}
      opts={{
        loop: false,
        dragFree: true,
      }}
      plugins={[]}
      setApi={setApi}
    >
      <CarouselContent className="h-[140px] -ml-0 gap-3">
        {stickers.map((sticker) => (
          <CarouselItem key={sticker.id} className="basis-[140px] grid pl-0">
            <AnimatedSticker
              autoplay={false}
              className="bg-white/10 border border-[#FFFFFF1A]"
              leading={false}
              loop={false}
              src={sticker.image}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};
